import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "o-grid o-grid--align-middle" }
const _hoisted_2 = { class: "o-grid__cell o-grid__cell--1" }
const _hoisted_3 = { class: "o-grid__cell o-grid__cell--12 form-actions u-mar-b-0 u-text-align-right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon_sprite = _resolveComponent("icon-sprite")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_icon_sprite, {
        "icon-name": "icon-check-mark",
        "ist-gross": true,
        "css-style": "color: green"
      })
    ]),
    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "o-grid__cell o-grid__cell--11" }, "Vielen Dank! Die E-Mail wurde erfolgreich versandt.", -1)),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("button", {
        class: "c-button",
        type: "button",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closeModal()))
      }, "OK")
    ])
  ]))
}